import { apiClient } from './client';
import type { AdminLoginResponse } from '../types';

export const authApi = {
  login: async (email: string, password: string): Promise<AdminLoginResponse> => {
    const response = await apiClient.post<AdminLoginResponse>('/api/auth/admin/login', {
      email,
      password,
    });
    return response.data;
  },
};
